import type { RouteObject } from 'react-router';
import { authRoutePatterns } from '@/auth/constants/routes';

export const authRouteChildren: RouteObject[] = [
  {
    path: authRoutePatterns.signIn,
    lazy: () => import('@/auth/pages/sign-in-page').then((m) => ({ Component: m.SignInPage })),
  },
  {
    path: authRoutePatterns.signUp,
    lazy: () => import('@/auth/pages/sign-up-page').then((m) => ({ Component: m.SignUpPage })),
  },
  {
    path: authRoutePatterns.forgotPassword,
    lazy: () => import('@/auth/pages/forgot-password-page').then((m) => ({ Component: m.ForgotPasswordPage })),
  },
  {
    path: authRoutePatterns.resetPassword,
    lazy: () => import('@/auth/pages/reset-password-page').then((m) => ({ Component: m.ResetPasswordPage })),
  },
];
